/**
 * 동시 세션 상한(설계서 §15 "동시 세션 상한", 2026-10-23) — 화면 공용 규칙.
 * 조직 상한(su [조직] 화면)과 사용자 상한(관리자 [사용자] 편집)이 **같은 입력·같은 표기**를 쓴다.
 *
 * 값 범위는 서버 `SESSION_LIMIT.MIN/MAX` 와 같아야 한다(서버가 최종 판정 — 화면은 미리 알려 줄 뿐).
 */
export const SESSION_LIMIT_MIN = 1;
export const SESSION_LIMIT_MAX = 1000;

/** 입력 칸이 비었을 때의 뜻 — 무제한(서버 null). */
export const SESSION_LIMIT_UNLIMITED_LABEL = '무제한';

/** 입력 칸 아래 안내 — 두 화면 공통. */
export const SESSION_LIMIT_HINT = `비우면 무제한 · ${SESSION_LIMIT_MIN}~${SESSION_LIMIT_MAX} · 낮춰도 지금 열린 세션은 끊지 않고 다음 접속부터 적용됩니다.`;

/** 표기: null/undefined(옛 서버) = "무제한". */
export function sessionLimitText(limit: number | null | undefined): string {
  return limit === null || limit === undefined ? SESSION_LIMIT_UNLIMITED_LABEL : String(limit);
}

/** 입력 칸의 초기 글자 — 무제한이면 빈 칸. */
export function sessionLimitInput(limit: number | null | undefined): string {
  return limit === null || limit === undefined ? '' : String(limit);
}

/**
 * 입력 글자 → 서버로 보낼 값. 빈 칸 = null(무제한). 정수 범위 밖·숫자 아님은 오류 문구.
 * @returns `{ ok: true, value }` 또는 `{ ok: false, error }`
 */
export function parseSessionLimit(text: string): { ok: true; value: number | null } | { ok: false; error: string } {
  const t = text.trim();
  if (t === '') return { ok: true, value: null };
  if (!/^\d+$/.test(t)) return { ok: false, error: '동시 세션 상한은 숫자로 입력하세요(비우면 무제한).' };
  const n = Number(t);
  if (n < SESSION_LIMIT_MIN || n > SESSION_LIMIT_MAX) {
    return { ok: false, error: `동시 세션 상한은 ${SESSION_LIMIT_MIN}~${SESSION_LIMIT_MAX} 사이로 입력하세요(비우면 무제한).` };
  }
  return { ok: true, value: n };
}
